import {Button, Card, Checkbox, Form, Input, Spin} from 'antd';
import React from 'react';
import {getFormFieldByType, sanitizeFieldName} from '../../util/methods';
import ComplaintModal from "../../components/ComplaintModal";
import AssetServiceSubList from "../../components/AssetServiceSubList";

class Create extends React.Component {

  constructor() {
    super();
    this.state = {
      keys: [],
      complaintData: [],
      checkPointsComplaint: [],
    };
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    const {data: {checkPoints = []}} = this.props;
    this.setState({
      keys: checkPoints,
      checkPointsComplaint: checkPoints,
    });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.data && nextProps.data.asset && (JSON.stringify(nextProps.data.asset) !== JSON.stringify(this.props.data.asset))) {
      nextProps.getComplaints(nextProps.data.asset._id);
    }

    if (nextProps.data && nextProps.data.checkPoints && JSON.stringify(nextProps.data.checkPoints) !== JSON.stringify(this.props.data.checkPoints)) {
      this.setState({
        keys: nextProps.data.checkPoints,
        checkPointsComplaint: nextProps.data.checkPoints,
      });
    }
  }

  getComplaintData(index, data) {
    const {checkPointsComplaint} = this.state;
    checkPointsComplaint[index].complaint = data;
    this.setState({checkPointsComplaint});
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      // todo
      values.checkPoints && values.checkPoints.map((item, index) => {
        if (item.isOk === null) {
          values[index].isOk = false;
        }
        if (item.linkedToInterval === null) {
          values[index].linkedToInterval = false;
        }
        values.checkPoints[index].complaint = this.state.checkPointsComplaint[index].complaint;
      });

      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  checkpointFormItems() {
    const {data, form, filters} = this.props;
    const {getFieldDecorator} = form;
    const {keys} = this.state;
    const style = {
      marginTop: '10px 0 5px 0',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      borderRadius: '9px',
      position: 'relative',
      margin: '1% 0',
      alignItems: 'center',
    };
    const formTailLayout = {};
    return keys.map((k, index) => {
      return <div key={index}>
        <div key={index} style={style}>

          <Form.Item key={`${index}6`} style={{display: 'none'}}>
            {getFieldDecorator(`checkPoints[${index}]['id']`, {
              rules: [{required: false, message: `id is required!`}],
              initialValue: data.checkPoints && data.checkPoints[index] && data.checkPoints[index]['id'],
            })(<input style={{display: 'none'}} disabled/>)
            }
          </Form.Item>

          <Form.Item key={`${index}1`} label={'Check Point'} style={{width: '78%', marginBottom: '5px'}}>
            {getFieldDecorator(`checkPoints[${index}]['checkPoint']`, {
              rules: [{required: true, message: `CheckPoint is required!`}],
              initialValue: data.checkPoints && data.checkPoints[index] && data.checkPoints[index]['checkPoint'],
            })(<Input disabled placeholder={'Rate'}/>)
            }
          </Form.Item>

          <Form.Item key={`${index}2`} label={'Linked to Interval'} style={{width: '18%', marginBottom: '5px'}}>
            {getFieldDecorator(`checkPoints[${index}]['linkedToInterval']`, {
              rules: [{required: false, message: `Linked to Interval is required!`}],
              valuePropName: 'checked',
              initialValue: data.checkPoints && data.checkPoints[index] && data.checkPoints[index]['linkedToInterval'],
            })(<Checkbox disabled></Checkbox>)
            }
          </Form.Item>

          <Form.Item key={`${index}4`} label={'Action Taken'} style={{width: '78%', marginBottom: '0px'}}>
            {getFieldDecorator(`checkPoints[${index}]['actionTaken']`, {
              rules: [{required: false, message: `Action Taken is required!`}],
              initialValue: data.checkPoints && data.checkPoints[index] && data.checkPoints[index]['actionTaken'],
            })(<Input placeholder={'Action Taken'} style={{marginRight: 8}}/>)
            }
          </Form.Item>

          <Form.Item key={`${index}3`} label={'Is Ok'} {...formTailLayout} style={{width: '18%', marginBottom: '0px'}}>
            {getFieldDecorator(`checkPoints[${index}]['isOk']`, {
              rules: [{required: false, message: `Is Ok is required!`}],
              valuePropName: 'checked',
              initialValue: data.checkPoints && data.checkPoints[index] && data.checkPoints[index]['isOk'],
            })(<Checkbox></Checkbox>)
            }
          </Form.Item>

          <div style={{width: '78%'}}>
            <ComplaintModal history={this.props.history} match={this.props.match} key={'complaint'} index={k.id}
                            form={form}
                            data={data['checkPoints'] && data.checkPoints[index]['complaint']}
                            complaints={this.props.complaints}
                            getComplaintData={this.getComplaintData.bind(this, index)}/>
          </div>

        </div>
        <hr/>
      </div>
    });
  }

  // handleSelect = (e) => {
  //   this.props.getEquipmentSubType(e);
  // };

  render() {
    const {getFieldDecorator, setFieldsValue} = this.props.form;
    const {data, loading, filters, title, resource, form, getComplaints, complaints, equipmentSubTypeData} = this.props;
    const {keys} = this.state;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              if (filters[item] && filters[item].options && filters[item].options.hidden) {
                return;
              }
              if (filters[item].type === 'Array' && filters[item].schema) {
                if (filters[item].field !== 'checkPoints') {
                  return <AssetServiceSubList key={item} item={filters[item]} form={form} data={data[item]} title={title} resource={resource}/>;
                }
              } else {
                  return getFormFieldByType(filters, item, getFieldDecorator, data, {resource, title, setFieldsValue});
              }
            })}
            {
              (title === 'EDIT' && keys && keys.length) ? <>
                <div>Checkpoints</div>
                {this.checkpointFormItems()}
              </> : ''
            }

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
